import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ExemptVendor } from './exempt-vendor';
import { Site } from './site';
import { User } from './user';
import { Vendor } from './vendor';

export class SiteUser extends BaseModel {
  static SiteUserProperties: (
    | {
        property: keyof SiteUser;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SiteUser;
        type: 'alias';
      }
    | {
        property: keyof SiteUser;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'SiteId', type: 'column', dataType: 'number' },
    { property: 'UserId', type: 'column', dataType: 'number' },
    { property: 'shouldNotify', type: 'column', dataType: 'boolean' },
    { property: 'isPrimary', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Site', model: 'Site', type: 'association' },
    { property: 'User', model: 'User', type: 'association' }
  ];

  static {
    SiteUser.SiteUserProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        SiteUser.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        SiteUser.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        SiteUser.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(SiteUserObject: Partial<SiteUser>) {
    super();

    SiteUser.SiteUserProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = SiteUserObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  SiteId?: number;
  UserId?: number;
  shouldNotify?: boolean;
  isPrimary?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  Site?: Site;
  User?: User;
}
